import type {Caption} from '@remotion/captions';

export const CAPTION_FPS = 30;

export const msToFrame = (ms: number) => Math.round((ms / 1000) * CAPTION_FPS);

export const fetchCaptions = async (src: string): Promise<Caption[]> => {
	const response = await fetch(src);
	if (!response.ok) {
		throw new Error(`Could not load captions from ${src}`);
	}
	return (await response.json()) as Caption[];
};

export type CaptionPage = {
	readonly words: Caption[];
	readonly lines: Caption[][];
	readonly startMs: number;
	readonly endMs: number;
};

export const buildCaptionPages = (
	captions: Caption[],
	options: {maxCharsPerLine: number; gapMs: number} = {maxCharsPerLine: 12, gapMs: 160},
): CaptionPage[] => {
	const groups: Caption[][] = [];
	let current: Caption[] = [];

	captions.forEach((caption, index) => {
		const previous = captions[index - 1];
		if (previous && caption.startMs - previous.endMs > options.gapMs && current.length > 0) {
			groups.push(current);
			current = [];
		}
		current.push(caption);
	});
	if (current.length > 0) {
		groups.push(current);
	}

	return groups.map((words) => {
		const lines: Caption[][] = [];
		let line: Caption[] = [];
		let lineLength = 0;

		for (const word of words) {
			const wordLength = word.text.replace(/\s/g, '').length;
			if (lineLength + wordLength > options.maxCharsPerLine && line.length > 0) {
				lines.push(line);
				line = [];
				lineLength = 0;
			}
			line.push(word);
			lineLength += wordLength;
		}
		if (line.length > 0) {
			lines.push(line);
		}

		return {
			words,
			lines,
			startMs: words[0].startMs,
			endMs: words[words.length - 1].endMs,
		};
	});
};
